import { EffectComposer, Bloom } from "@react-three/postprocessing";

export default function Effects() {
  return (
    <EffectComposer>
      <Bloom mipmapBlur intensity={0.5} luminanceThreshold={1} />
    </EffectComposer>
  );
}
